// Imports
import axios from 'axios'

// App Imports
import { API_URL } from '../../../../setup/config/env'

// Actions
import {
  FETCH_SETTING_DETAIL,
  FETCH_SETTING_DETAIL_SUCCESS,
  FETCH_SETTING_DETAIL_FAILURE,
} from './types';

// Get detail
export function detail({ vendorId }) {
  return dispatch => {
    return axios.post(`${API_URL}/api/setting`, {
      "vendorId": vendorId
    })
  }
}

export const fetchSettingDetail = (vendorId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_SETTING_DETAIL });

    try {
      const { data } = await axios.post(
        `${API_URL}/api/setting`,
        { vendorId }
      );

      if (!data.error && data?.data) {
        dispatch({
          type: FETCH_SETTING_DETAIL_SUCCESS,
          payload: data.data,
        });
      } else {
        dispatch({
          type: FETCH_SETTING_DETAIL_FAILURE,
          payload: data.error || 'Something went wrong',
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_SETTING_DETAIL_FAILURE,
        payload: error.message || 'Something went wrong',
      });
    }
  };
};

// Get All Country Codes
export function getAllCountryCodes() {
  return dispatch => {
    return axios.get(`${API_URL}/api/countryCode`)
  }
}

// Get All Currencies
export function getAllCurrencies() {
  return dispatch => {
    return axios.get(`${API_URL}/api/currency`)
  }
}


export function settingDetail() {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'settingDetail'
    })
  }
}

export function getHolidayCollections(params) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'getHolidayCollections',
      params
    })
  }
}

// Get preferred topics from settings (used by AI Blog)
export function getPreferredTopics() {
  return dispatch => {
    return axios.post(`${API_URL}/api/setting`)
      .then(res => ({
        data: {
          success: res.data.success,
          data: res.data.data?.preferredTopics || []
        }
      }));
  };
}